//write global states and switch state to set state here
//import {combineReducers} from 'redux';
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import API, { URL_PATH } from "../services/API";
import Strings from "./Strings";
//import hardSet from "redux-persist/lib/stateReconciler/hardSet";

import Cookies from "js-cookie";

const initialState = {
  lang: "en",
  drawerShown: true,
  donationOpen: true,
  langSelectorOpen: true,
  okDialogMessage: "",
  okDialogShown: false,
  isAuth: false,
  userData: {},
  loading: false,
    receiptFooter: null, // Add this new property

  hotels: [],
  selectedHotelId: null,
  accessControl: [],
  subscriptionActive: false,
  hotelSelectedId: null,
  pendingBookingCount: null,
  pendingPickupCount: null,
  dineInCount: null,
  paymentRequestCount: null,
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "lang",
    "langSelectorOpen",
    "isAuth",
    "userData",
    "subscriptionActive",
    "hotels",
    "hotelSelectedId",
    "receiptFooter", // Add this if you want it persisted
  ],
};
/*
only use one at time
blacklist: ['state1','state2','state3',...] // navigation will not be persisted
   whitelist: ['state1','state2','state3',...] // only navigation will be persisted
*/

const _update = (key, value, state) => {
  let t = { ...state };
  t[key] = value;
  return t;
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PENDING_BOOKING_COUNT":
      return _update("pendingBookingCount", action.value, state);

    case "SET_PENDING_PICKUP_COUNT":
      return _update("pendingPickupCount", action.value, state);

    case "SET_DINE_IN_COUNT":
      return _update("dineInCount", action.value, state);

    case "SET_PAYMENT_REQUEST_COUNT":
      return _update("paymentRequestCount", action.value, state);

    case "SET_HOTEL_SELECTED_ID":
      return _update("hotelSelectedId", action.value, state);

    case "SET_HOTELS":
      return _update("hotels", action.value, state);
    case "SET_SUBSCRIPTION_ACTIVE":
      return _update("subscriptionActive", action.value, state);
    case "SET_ACCESS_CONTROL":
      return _update("accessControl", action.value, state);

    case "SET_SELECTED_HOTEL_ID":
      Cookies.set("selectedHotelId", action.value.id);
      return _update("selectedHotelId", action.value, state);
    case "SET_USER":
      return _update("userData", action.value, state);
    case "SET_AUTH":
      return _update("isAuth", action.value, state);
    case "SET_LANGUAGE":
      Strings.setLanguage(action.value ?? "en");
      return _update("lang", action.value, state);
    case "setDrawerShown":
      return _update("drawerShown", action.value, state);
    case "setDonationOpen":
      return _update("donationOpen", action.value, state);
    case "setLangSelectorOpen":
      return _update("langSelectorOpen", action.value, state);
    case "setOkDialogShown":
      return _update("okDialogShown", action.value, state);
    case "setOkDialogMessage":
      return _update("okDialogMessage", action.value, state);
    case "setLoading":
      return _update("loading", action.value, state);
      case "SET_RECEIPT_FOOTER":
  return _update("receiptFooter", action.value, state);
  }
  return state;
};

export default persistReducer(persistConfig, userReducer);
//export default combineReducers({user: userReducer});
